// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"8e5bff6b","103":"51d61531","321":"e2edac05","583":"845306a8","591":"ecd6bc75","616":"480b13e7","790":"df43ecb9","805":"903bb52e","906":"3176543b"}[chunkId] + ".chunk.js";
};